/*@flow*/
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Switch, Route } from 'react-router-dom';
import { connect } from 'react-redux';
import { IntlProvider, addLocaleData } from 'react-intl';
import locale_en from 'react-intl/locale-data/en';
import locale_de from 'react-intl/locale-data/de';
import locale_fr from 'react-intl/locale-data/fr';
import locale_es from 'react-intl/locale-data/es';
import locale_it from 'react-intl/locale-data/it';
import locale_pt from 'react-intl/locale-data/pt';

import ResultsRedirect from './components/ResultsRedirect';
import Header from './components/Header';
import Result from './pages/Result/index';
import AdvancedSearch from './pages/AdvancedSearch';
import Footer from './components/Footer';
import CurrentLocale from './CurrentLocale';
import { getOrganizations } from './actions/organizations';

import fr from './translations/fr.json';
import en from './translations/en.json';
import de from './translations/de.json';
import pt from './translations/pt.json';

addLocaleData([
  ...locale_en,
  ...locale_de,
  ...locale_fr,
  ...locale_es,
  ...locale_it,
  ...locale_pt
]);

class App extends Component {
  componentDidMount() {
    this.props.getOrganizations();
  }
  render() {
    const { lang } = this.props;

    const messages = {
      fr,
      en,
      pt,
      de
    };

    return (
      <IntlProvider locale={lang} messages={messages[lang]}>
        <React.Fragment>
          <CurrentLocale />
          <Header />
          <main className="wrap-container">
            <Switch>
              <Route exact path="/results" component={ResultsRedirect} />
              <Route exact path="/advanced" component={AdvancedSearch} />
              <Route exact path="/" component={Result} />
            </Switch>
          </main>
          <Footer />
        </React.Fragment>
      </IntlProvider>
    );
  }
}

export default withRouter(
  connect(
    ({ ui: { lang } }) => ({ lang }),
    dispatch => ({
      getOrganizations: () => dispatch(getOrganizations())
    })
  )(App)
);



// WEBPACK FOOTER //
// ./src/App.js